export const ANY_RID = 'ANY_RID';
